
import { defineComponent } from "vue";

export default defineComponent({
  name: "WhyBank",
  props: {
    imagem: {
      type: Object,
      required: true,
    },
  },
});
